var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.$route.fullPath?.split('?')[0],attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }